import { InlineLink } from '@bounty/creators-design-system'
import * as B from '../../BountyDetailParts'

export const BountyDetailError = ({
  data,
  ...props
}: Omit<B.PageProps, 'children'>) => {
  return (
    <B.Page data={data} {...props}>
      <B.SparkCodes />
      <B.SectionGroup>
        <B.TitleRow />
        <B.StatusCard>
          <B.StatusHeading>Error</B.StatusHeading>
          <B.StatusParagraph>
            Something went wrong with this Bounty.{' '}
            <InlineLink
              href={'mailto:helpdesk@gen.video'}
              size="$sm"
              color="$neutral.50"
              event="Bounty Detail Contact Support Clicked"
            >
              Contact support
            </InlineLink>{' '}
            for more information.
          </B.StatusParagraph>
        </B.StatusCard>
        <B.HowBountyWorksCard />
      </B.SectionGroup>
      <B.MinimumPayout />
      <B.CommunityRules />
      <B.OrderDetails />
    </B.Page>
  )
}
